import { Theme } from "@mui/material";

export const generateTreeStyles = (color: string | undefined, theme: Theme) => ({
  root: {
    flexGrow: 1,
    background: "#fff",
    margin: theme.spacing(1),
    borderRadius: 8,
    border: "1px solid #D0D5DD",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column" as const,
    "&::before": {
      content: '""',
      display: "block",
      height: 12,
      background: color,
      flexShrink: 0,
    },
  },
  title: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  tree: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column" as const,
    gap: 10,
  },
  content: {
    flexGrow: 1,
    overflowY: "auto" as "auto",
  },
});
